import Vue from 'vue'
import Vuex from 'vuex'
import firebase from 'firebase'
import randomize from 'randomatic'
import ApiRepository from "../core/ApiRepository";
import AuthenticationApp from "../core/AuthenticationApp";
/*import GetConstants from '../core/Constants';
var Constants = GetConstants.getConstans();*/
Vue.use(Vuex)

const currentModuleFromUrl = new URLSearchParams(window.location.search).get('module');
const moduleStoreSaved = currentModuleFromUrl || sessionStorage.getItem('moduleStore') || localStorage.getItem('moduleStore');

export default new Vuex.Store({
  state: {
    user: null,
    status: null,
    error: null,
    userProfile: {},
    fullname: null,
    isLoggedIn: false,
    isHomePage: false,
    token: null,
    token_refesh: null,
    sentRequest: null,
    isLoading: false,
    role: null,
    unsaveChange: null,
    department: [],
    company: [],
    type : null,
    company_id: null,
    controllers: {},
    deviceToken: null,
    typeCompany : null,
    roleCompany : null,
    company_type : null,
    moduleStore: moduleStoreSaved || null,
  },
  mutations: {
    setUser(state, payload) {
      state.user = payload
    },
    setFullname(state, payload) {
      state.fullname = payload
    },
    removeUser(state) {
      state.user = null
    },
    setStatus(state, payload) {
      state.status = payload
    },
    setError(state, payload) {
      state.error = payload
    },
    setIsLoggedIn(state, payload) {
      state.isLoggedIn = payload
    },
    setIsHomePage(state, payload) {
      state.isHomePage = payload
    },
    setToken(state, payload) {
      state.token = payload
    },
    setTokenRefesh(state, payload) {
      state.token_refesh = payload
    },
    setSentRequest(state, payload) {
      state.sentRequest = payload
    },
    setRole(state, payload) {
      state.role = payload
    },
    setType(state, payload) {
      state.type = payload
    },
    setLoading(state, payload) {
      state.isLoading = payload
      setTimeout(function () {
        state.isLoading = false
      }, 5000)
    },
    clearUnsavedChange(state) {
      state.unsaveChange = null
    },
    setDepartment(state, payload) {
      state.department = payload
    },
    setListCompany(state, payload) {
      state.company = payload
    },
    setCompany(state, payload) {
      state.company_id = payload
    },
    setControllers(state, payload) {
      state.controllers = payload
    },
    setDeviceToken(state, payload) {
      state.deviceToken = payload
    },
    setCompanyName(state, payload) {
      state.company = payload
    },
    setLogo(state, payload) {
      state.logo = payload
    },
    setRoleCompany(state, payload) {
      state.roleCompany = payload
    },
    setTypeCompany(state, payload) {
      state.typeCompany = payload
    },
    setCompanyType(state, payload) {
      state.company_type = payload
    },
    setModuleStore(state, payload) {
      state.moduleStore = payload
      if (payload) {
        sessionStorage.setItem('moduleStore', payload)
        localStorage.setItem('moduleStore', payload)
      } else {
        sessionStorage.removeItem('moduleStore')
        localStorage.removeItem('moduleStore')
      }
    }
  },
  actions: {
    deleteUserAction({commit}, payload) {
      console.log('deleteUserAction', payload)
      return new Promise((resolve, reject) => {
        firebase.auth().deleteUser(payload.uid)
        .then((response) => {
          resolve(response)
          resolve('OK')
        })
        .catch((error) => {
          commit('setError', error.message)
          reject(error)
        });
      })
    },
    resetPasswordAction({commit}, payload) {
      return new Promise((resolve, reject) => {
        var code = randomize('0', 6);
        firebase.auth().sendPasswordResetEmail(payload.email, code)
        .then((response) => {
          resolve(response)
          resolve('OK')
        })
        .catch((error) => {
          commit('setError', error.message)
          reject(error)
        });
      })
    },
    signUpAction({commit}, payload) {
      return new Promise((resolve, reject) => {
        firebase.auth().createUserWithEmailAndPassword(payload.email, payload.password)
        .then(async (response) => {
          await response.user.sendEmailVerification();
          resolve(response)
          resolve('OK')
        })
        .catch((error) => {
          commit('setError', error.message)
          reject(error)
        })
      })
    },
    signInAction({ commit }, payload) {
      return new Promise((resolve, reject) => {
        ApiRepository.post('/_api/users/login-admin',payload).then(async (response) => {
          var dataSuccess = response.data;
          var dataUser = dataSuccess.data;
          console.log("dataUserdataUserdataUser:",dataUser)
          commit('setUser', dataUser.id)
          commit('setStatus', 'success')
          commit('setError', null)
          commit('setToken', dataUser.token);
          commit('setType', dataUser.type)
          commit('setTokenRefesh', dataUser.token_refesh);
          commit('setRole', dataUser.role);
          commit('setDepartment', dataUser.list_department);
          commit('setListCompany', dataUser.list_id_company);
          commit('setCompany', dataUser.company_id);
          commit('setFullname', dataUser.fullname);
          commit('setRoleCompany', dataUser.role_company);
          commit('setTypeCompany', dataUser.type_company);
          commit('setCompanyType', dataUser.company_type);
          
          var dataState = dataUser;
          dataState["uid"] = dataUser.id
         /* var dataState = {
            uid:dataUser.id,
            token:dataUser.token,
            token_refesh:dataUser.token_refesh,
          }*/
          await AuthenticationApp.setStateLogin(dataState);
          AuthenticationApp.setinfoNormal(dataState);
          resolve(response)
          // resolve(dataUser.token);
        })
            .catch((error) => {
              commit('setStatus', 'failure')
              commit('setError', error.message)
              reject(error)
            })

        /*firebase.auth().signInWithEmailAndPassword(payload.email, payload.password)
          .then(async (response) => {
            commit('setUser', response.user.uid)
            commit('setStatus', 'success')
            commit('setError', null)
            var token = await response.user.getIdToken(true)
            commit('setToken', token)
            resolve(response)
            resolve('OK')
          })
          .catch((error) => {
            commit('setStatus', 'failure')
            commit('setError', error.message)
            reject(error)
          })*/
      })
    },
    signOutAction({ commit }) {
      commit('setUser', null)
      commit('setFullname', null)
      commit('setStatus', 'success')
      commit('setError', null)
      commit('setToken', null)
      commit('setType', null)
      commit('setRole', null)
      commit('setDepartment', [])
      commit('setListCompany', [])
      commit('setCompany', null)
      commit('setRoleCompany', null);
      commit('setTypeCompany', null);
      commit('setCompanyType', null);
    },
    /*signOutAction({ commit }) {
      firebase.auth().signOut()
        .then(() => {
          // console.log(response)
          commit('setUser', null)
          commit('setStatus', 'success')
          commit('setError', null)
          commit('setToken', null)
        })
        .catch((error) => {
          commit('setStatus', 'failure')
          commit('setError', error.message)
        })
    },*/
    CreateQR({ commit },payload) {
      return new Promise((resolve, reject) => {
        ApiRepository.post('/_api/users/create_qr_ipro_code_restore',payload).then(async (response) => {
          commit('setError', null)
          resolve(response)
          resolve('OK')
        })
          .catch((error) => {
            reject(error)
          })
      })
    },
  },

  getters: {
    status(state) {
      return state.status
    },
    user(state) {
      return state.user
    },
    fullname(state) {
      return state.fullname
    },
    isLoggedIn(state) {
      return state.isLoggedIn
    },
    error(state) {
      return state.error
    },
    isHomePage(state) {
      return state.isHomePage
    },
    token(state) {
      return state.token
    },
    tokenRefesh(state) {
      return state.token_refesh
    },
    sentRequest(state) {
      return state.sentRequest
    },
    role(state) {
      return state.role
    },
    type(state) {
      return state.type
    },
    isLoading(state) {
      return state.isLoading
    },
    unsaveChange(state) {
      return state.unsaveChange
    },
    department(state) {
      return state.department;
    },
    company(state) {
      return state.company;
    },
    company_id(state) {
      return state.company_id;
    },
    controllers(state) {
      return state.controllers;
    },
    deviceToken(state) {
      return state.deviceToken;
    },
    roleCompany(state) {
      return state.roleCompany
    },
    typeCompany(state) {
      return state.typeCompany
    },
    companyType(state) {
      return state.company_type
    },
    moduleStore(state) {
      return state.moduleStore
    }
  }
})
